import React from 'react';
import { Box, Typography } from '@mui/material';
import { display, eyebrow } from '../actionables/brand';

// Shared compact stat tile for the new design language. Two shapes, both reproduced byte-for-byte
// from the former per-page render helpers:
//  - `plain`   (default): the simple pill (no strip, no icon) — Inventory "Total Quantity" + the
//                         two Draft Bundles toolbar pills.
//  - `summary`          : the accent-strip + trailing-icon tile — Inventory's four summary pills.
// `accent` colours the number (and, in the summary variant, the 5px left strip + icon).
const StatPill: React.FC<{
    label: string;
    value: React.ReactNode;
    accent: string;
    icon?: React.ReactNode;
    variant?: 'plain' | 'summary';
}> = ({ label, value, accent, icon, variant = 'plain' }) => {
    if (variant === 'summary') {
        return (
            <Box
                sx={{
                    position: 'relative', overflow: 'hidden', flex: '1 1 160px', minWidth: 140,
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1,
                    pl: 2.25, pr: 1.75, py: 1.25, borderRadius: '14px', bgcolor: '#fff',
                    border: '1px solid #ECECE4', boxShadow: '0 1px 2px rgba(26,20,15,0.04)',
                    '&::before': {
                        content: '""', position: 'absolute', left: 0, top: 0, bottom: 0, width: 5,
                        bgcolor: accent,
                    },
                }}
            >
                <Box>
                    <Typography sx={{ ...eyebrow, color: '#8A8078', fontSize: '0.6rem' }}>{label}</Typography>
                    <Typography sx={{ ...display('1.6rem'), color: accent, mt: 0.2 }}>{value}</Typography>
                </Box>
                {icon && <Box sx={{ display: 'flex', alignItems: 'center', color: accent }}>{icon}</Box>}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                px: 1.75, py: 0.75, borderRadius: '14px', bgcolor: '#fff',
                border: '1px solid #ECECE4', minWidth: 104,
            }}
        >
            <Typography sx={{ ...eyebrow, color: '#8A8078', fontSize: '0.6rem' }}>{label}</Typography>
            <Typography sx={{ ...display('1.3rem'), color: accent, mt: 0.2 }}>{value}</Typography>
        </Box>
    );
};

export default StatPill;
